export default __webpack_public_path__ + "static/jendrik-closeup-40d7431fc747d6011fbf601a0617763b.jpg";